module.exports = __webpack_public_path__ + "img/Collaborative.6e22f6c6.png";